import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Layout } from "../pages/landing/Layout";
import { Loader } from "../components/Loader";
import { SellFaq } from "../sections/SellFaq";
import { CallToAction } from "../sections/CallToAction";
import { InteriorDesignHow } from "../sections/interior_design/InteriorDesignHow";
import { PatternDiscover } from "../sections/pattern/PatternDiscover";
import { InteriorDesignBanner } from "../sections/interior_design/InteriorDesignBanner";
import { FeatureImageCfLeft } from "../sections/FeatureImageCfLeft";
import { FeatureImageCfRight } from "../sections/FeatureImageCfRight";

export const interior_design_generator_faq_data = [
    {
        question: "Can I virtual stage my space?",
        answer: "Yes, you can virtual stage your space. You can upload your space photo and our interior design generator will fill empty spaces with furniture and decor while maintaining the original structure and layout.",
    },
    {
        question:
            "Can I use the generated interior designs for commercial purposes?",
        answer: "Yes, you can use the generated interior designs for commercial purposes. You can use the generated interior designs in your online listing, social media, or any other platform.",
    },
    {
        question: "What output formats are available?",
        answer: "We offer the following output formats: PNG, JPEG, and WEBP.",
    },
    {
        question: "What about privacy? Are my interior design photos safe?",
        answer: "Yes, your images are safe with us. Patternful.ai prioritizes user data safety. Your images are always private, proprietary, and they remain your property. All your uploaded images are automatically deleted from our servers after a few hours.",
    },
];

class InteriorDesignLanding extends Component {
    constructor(props) {
        super(props);
        this.state = { isLoading: true };
    }
    componentDidMount() {
        this.setState({ isLoading: false });
    }

    render() {
        if (this.state.isLoading) {
            return <Loader />;
        }
        return (
            <Layout>
                <Helmet>
                    <title>Interior Design Generator</title>
                    <meta
                        name="description"
                        content="Generate interior designs in various styles."
                    />
                    <meta
                        name="keywords"
                        content="Interior Design Generator, AI Interior Design Generator, Interior Design Generator APP, Interior Design Online Generator, Image Processing, AI Image Editing, Patternful, Patternful AI"
                    />
                </Helmet>
                <InteriorDesignBanner />
                <InteriorDesignHow />
                <FeatureImageCfLeft
                    beforeImage={"/images/interior-design/1.webp"}
                    afterImage={"/images/interior-design/1_japanese.webp"}
                    title={"Fill the Space in Various Styles"}
                    description={
                        "The interior design generator intelligently generates interior designs in various styles. It is particularly useful for homeowners, renters, and anyone looking to improve the aesthetics of their space."
                    }
                />
                <FeatureImageCfRight
                    beforeImage={"/images/interior-design/7.webp"}
                    afterImage={"/images/interior-design/7_generated.webp"}
                    title={"Redesign Your Space"}
                    description={
                        "Transform your space with endless possibilities — explore different themes, mix and match styles, experiment with colors, and refresh your furniture to create a look that feels uniquely yours."
                    }
                />
                <FeatureImageCfLeft
                    beforeImage={"/images/interior-design/8.webp"}
                    afterImage={"/images/interior-design/8_generated.webp"}
                    title={"Plan Your Outdoor Space"}
                    description={
                        "Plan your patio, backyard, or garden with beautiful flowers, vibrant plants, stylish furniture, and more — everything you need to create your ideal outdoor oasis and bring your vision to life."
                    }
                />
                <FeatureImageCfRight
                    beforeImage={"/images/interior-design/9.webp"}
                    afterImage={"/images/interior-design/9_generated.webp"}
                    title={"Showcase In Real Estate Listings"}
                    description={
                        "Enhance your real estate listings with stylish interior designs — ideal for agents and homeowners aiming to make a lasting impression."
                    }
                />
                <CallToAction
                    title={"Upload to Generate Interior Designs"}
                    subtitle={
                        "It has never been this easy to generate professional interior designs! Simply upload your space photo and let our interior design generator do the work. "
                    }
                    link={"/interior-design-generator/app"}
                    cta={"Get Started Now"}
                />
                <SellFaq data={interior_design_generator_faq_data} />
                <PatternDiscover />
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return { userAccount: state.authReducer?.userAuth.userAccount };
}

export default connect(mapStateToProps, {})(withRouter(InteriorDesignLanding));
